module.exports = __webpack_public_path__ + "res/img_landing_4.eeb71fb9306c1365d1cf1d200af77c7a.webp";